export default "__VITE_PUBLIC_ASSET__a45d66cf__"